import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientimmunicationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientimmunicationMst {

    id?: number;

    planned_Date:Date;
    done_Date:Date;
    notes:string;
    vaccineId:any;
    obstericsId:any;
    visitId:any;
    regId: string;     
    tenantId: any;
    branchId: any;
    pcId?:number;
    name?:string;
    parameters?: PatientimmunicationParameter[];
    links?: any;
    createdDate?:Date;
    createdBy?:number;
    careTaskType?:number;
    isPastVaccine?:boolean;
    performingDoctor?:string;
    performingNurse?:string;
}
export abstract class PatientimmunicationData { 
    
    abstract list(url: string): Observable<PatientimmunicationMst[]>;
    abstract create(url: string, data: PatientimmunicationMst): Observable<any>;
    abstract update(url: string, data: PatientimmunicationMst): Observable<any>;
    abstract delete(url: string): Observable<any>;    

}
